import { router } from '@inertiajs/vue3';

export const ZiggyUpdaterPlugin = {
    install() {
        // Update Ziggy routes when Inertia receives a successful response,
        // before the new page component renders. This ensures route()
        // calls in templates have the correct routes available (e.g. after
        // login transitions from guest to authenticated route groups).
        router.on('success', (event) => {
            const ziggy = event.detail.page.props.ziggy;
            if (ziggy) {
                window.Ziggy = ziggy;
            }
        });
    }
};
